/**
 * Popup Service
 * Handles all popup notification-related API calls
 */

import { apiGet } from './apiClient';
import API_CONFIG from './apiConfig';

/**
 * Get active popups for the user
 * @returns {Promise} { success, data: Array<popup> }
 */
export const getActivePopups = async () => {
  return apiGet(API_CONFIG.endpoints.popups);
};

/**
 * Mark a popup as viewed
 * @param {string} popupId - Popup ID
 * @returns {Promise} { success, message }
 */
export const markPopupAsViewed = async (popupId) => {
  return apiGet(API_CONFIG.endpoints.popupViewed(popupId));
};

